import React from 'react';


const PrizeBox = ({number, prize, type, txt, style}) => {
  // style = `w-[200px] laptop:w-[160px] h-14 flex flex-col justify-center items-center rounded-lg border-2 border-[#FBB403] text-[#0987F3] text-md mobile:w-[150px] ${style}`
  if(type){
    return (
      <div className={style}>
          <p className='font-bold'>{prize}</p>
          <p>{txt}</p>
      </div>
    );
  }else{
    return (
      <div className="w-[200px] laptop:w-[160px] h-14 flex flex-col justify-center items-center rounded-lg border-2 border-[#FBB403] text-[#0987F3] text-md mobile:w-[150px]">
          <p>{number} орон таарвал</p>
          <p className='font-bold'>{prize}₮</p>
      </div>
    );
  }
}

export default PrizeBox;